import { useQuery } from '@tanstack/react-query';
import type { ApiResponseBody } from '@/lib/api/api-type-helper';
import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { QUERY_PRESETS } from '@/lib/query';

/** 概要タブ シャドー検知/推移カード用のレスポンス型（当月・前月実件数・前月比を含む） */
export type OverviewShadowDetectionResponse = ApiResponseBody<'/v2/accesses/overview/shadow-detection', 'get'>;

// 利用メンバーの母数（在籍メンバー総数 ALL_ACTIVE）。利用率の分母に使う。
async function getActiveMemberCount() {
  const res = await apiClient.GET('/v2/people/count');
  return getDataOrThrowApiError(res);
}
export function useActiveMemberCount() {
  return useQuery({
    queryKey: ['accesses', 'overview', 'active-member-count'],
    queryFn: getActiveMemberCount,
    ...QUERY_PRESETS.list()
  });
}

// 概要タブ「シャドー検知」「シャドー検知の推移」用。アラートタブが参照する月次サマリー
// （検知済み総数＝全期間累計）とは別に、first_detected_at で「今月の新規検知」を集計する
// 概要タブ専用エンドポイント。両者を分離することで、片方の変更がもう片方へ波及しない。
async function getOverviewShadowDetection() {
  const res = await apiClient.GET('/v2/accesses/overview/shadow-detection');
  return getDataOrThrowApiError(res);
}
export function useOverviewShadowDetection() {
  return useQuery({
    queryKey: ['accesses', 'overview', 'shadow-detection'],
    queryFn: getOverviewShadowDetection,
    ...QUERY_PRESETS.list()
  });
}